function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
$(function () {
  function updateCartCount() {
    jQuery.getJSON(window.Shopify.routes.root + 'cart.json', function (cartData) {
      var cartCount = cartData.item_count;
      jQuery('#CartCount').text(cartCount);
    });
  }

  $('[data-add-to-cart]').off('click').on('click', function (event) {
    event.preventDefault();
    if (event.target.value) {
      event.target.closest('form').querySelector('input[name=id]').value = event.target.value
    }
    const form = event.target.closest('form[action$="/cart/add"]');
    jQuery.post(window.Shopify.routes.root + 'cart/add.js', $(form).serialize())
      .done(function (data) {
        updateCartCount();
        $('.cart-message').show();
      })
      .fail(function (jqXHR, textStatus, errorThrown) {
        console.error('Error:', textStatus, errorThrown);
      });
  });
  $('#continue-shop').on('click', function (e) {
    e.preventDefault();
    $('.cart-message').hide();
  })  

  $(window).on('click', function (event) {
    var statu = $('.site-header').hasClass('active');
    var isHeader = event.target.closest('.header-table');
    if (statu && !event.target.closest('.header__active')) {
      document.querySelector('.header__close').click();
      $('body').css('margin-top', '0')
    }

  })
})